import { c as _c } from "react/compiler-runtime";
import { Badge } from '@/frontend/design-system/data-display/Badge';
type SkillBadgeProps = {
  skill: string;
};
export function SkillBadge(t0) {
  const $ = _c(2);
  const {
    skill
  } = t0;
  let t1;
  if ($[0] !== skill) {
    t1 = <Badge className="bg-blue-100 px-2 py-1 font-medium text-blue-700">{skill}</Badge>;
    $[0] = skill;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}